export default "__VITE_ASSET__BuDdHk0A__"